var map = {
	"./all_dark.svg": "40f7",
	"./all_light.svg": "dff3",
	"./infrastructure_dark.svg": "36fe",
	"./infrastructure_light.svg": "dd9a",
	"./license_dark.svg": "4408",
	"./license_light.svg": "5d39",
	"./network_dark.svg": "6d60",
	"./network_light.svg": "c808",
	"./security_dark.svg": "b1e5f",
	"./security_light.svg": "14d4",
	"./service_dark.svg": "c68c",
	"./service_light.svg": "8b49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac55";